import { images } from '../constants';

const products = [ 
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Coffee Mug",
        price: 25,
        disprice: 20,
        stock: 5,
        content:
            "Enjoy your favorite beverages in style with our Premium Coffee Mug, perfect for event giveaways and conference merchandise. Designed with a sleek finish and ergonomic handle, this mug ensures a comfortable grip and an elegant look.",
        description:
            "Our Premium Coffee Mug is a must-have for event attendees and coffee enthusiasts. Made from high-quality ceramic with a glossy finish, it keeps your drink warm and enhances your coffee experience. Ideal for branding, conferences, and special events.",
        category: ["Event Merchandise", "Promotional Gifts"],
        tags: ["Merchandise", "Gifts", "Promo"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Quality Ceramic" },
            { id: 2, title: "Capacity", content: "12 oz (355 ml)" },
            { id: 3, title: "Finish", content: "Glossy with Custom Branding Option" },
            { id: 4, title: "Microwave Safe", content: "Yes" },
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Michael Carter",
                date: "August 10, 2024",
                rating: 5,
                content: "Excellent quality and perfect for corporate gifting! Love the branding options.",
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Sophia Martinez",
                date: "August 15, 2024",
                rating: 4.8,
                content: "A great souvenir from the conference. The mug feels premium and durable!",
            },
        ],
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Baseball Cap",
        price: 30,
        disprice: 25,
        stock: 10,
        content:
            "Stay stylish and comfortable with our Classic Baseball Cap, perfect for event giveaways and conference merchandise. Designed with a curved brim and adjustable strap, this cap ensures a perfect fit for everyone.",
        description:
            "Our Classic Baseball Cap is a must-have for event attendees and brand promotions. Made from high-quality cotton with breathable panels, it offers a stylish look while keeping you cool. Ideal for branding, conferences, and outdoor events.",
        category: ["Branded Apparel", "Event Merchandise"],
        tags: ["Wearable", "Merchandise", "Promo"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "100% Premium Cotton" },
            { id: 2, title: "Adjustability", content: "One Size Fits Most (Adjustable Strap)" },
            { id: 3, title: "Ventilation", content: "Breathable Mesh Panels" },
            { id: 4, title: "Customization", content: "Embroidery & Logo Printing Available" },
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Daniel Roberts",
                date: "August 20, 2024",
                rating: 5,
                content: "High-quality cap with a great fit. Perfect for corporate events!",
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Emily Johnson",
                date: "August 25, 2024",
                rating: 4.9,
                content: "Love the comfort and style! The logo customization looks fantastic.",
            },
        ],
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Notebook Set",
        price: 40,
        disprice: 35,
        stock: 20,
        content:
            "Enhance your note-taking experience with our Executive Notebook Set, designed for professionals and event attendees. This stylish set includes a premium notebook and matching pen, perfect for conferences, meetings, and corporate gifting.",
        description:
            "Our Executive Notebook Set is an ideal companion for brainstorming sessions, corporate meetings, and event giveaways. Featuring a sleek hardcover design, high-quality paper, and a smooth-writing pen, this set ensures a premium writing experience. Perfect for branding and customization.",
        category: ["Office Supplies", "Event Merchandise"],
        tags: ["Stationery", "Office", "Conference"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Hardcover with Premium Paper" },
            { id: 2, title: "Paper Type", content: "Lined, 80 GSM, 100 Pages" },
            { id: 3, title: "Pen Included", content: "Metal Ballpoint Pen" },
            { id: 4, title: "Customization", content: "Logo Printing & Embossing Available" },
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "David Richardson",
                date: "August 18, 2024",
                rating: 5,
                content: "Perfect for business meetings and conferences. The quality is top-notch!",
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Olivia Bennett",
                date: "August 22, 2024",
                rating: 4.9,
                content: "The notebook feels premium, and the pen writes smoothly. Great for events!",
            },
        ],
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Hoodie Sweater",
        price: 60,
        disprice: 50,
        stock: 0,
        content:
            "Stay warm and stylish with our Classic Hoodie Sweater, perfect for event giveaways and casual wear. Designed for comfort and durability, this hoodie is a must-have for any conference or promotional event.",
        description:
            "Our Classic Hoodie Sweater combines fashion and function, making it ideal for both work and leisure. Made from a high-quality cotton blend, it offers a soft feel and a relaxed fit. Perfect for branding, corporate gifts, or everyday wear.",
        category: ["Branded Apparel", "Event Merchandise"],
        tags: ["Wearable", "Merchandise", "Accessories"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Cotton Blend with Fleece Lining" },
            { id: 2, title: "Sizes Available", content: "S - XXL" },
            { id: 3, title: "Fit", content: "Relaxed and Comfortable" },
            { id: 4, title: "Customization", content: "Logo Printing & Embroidery Available" },
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Daniel Roberts",
                date: "August 25, 2024",
                rating: 5,
                content: "Super comfortable and great quality! Perfect for chilly event days.",
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Emily Johnson",
                date: "August 28, 2024",
                rating: 4.9,
                content: "Soft, warm, and stylish. A fantastic addition to any conference merchandise lineup!",
            },
        ],
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Pen Set",
        price: 25,
        disprice: 20,
        stock: 150,
        content:
            "Elevate your writing experience with our Executive Pen Set, perfect for corporate events and professional use. This premium set includes two high-quality pens, designed for smooth and effortless writing.",
        description:
            "Our Executive Pen Set is the perfect blend of style and functionality. Ideal for business professionals, conference attendees, and event giveaways, this set features a sleek and durable design. Available for customization with logo printing.",
        category: ["Office Supplies", "Promotional Gifts"],
        tags: ["Writing", "Office", "Stationery"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Metal with Chrome Finish" },
            { id: 2, title: "Ink Type", content: "Smooth Black Gel Ink" },
            { id: 3, title: "Set Includes", content: "Two Pens in a Gift Box" },
            { id: 4, title: "Customization", content: "Logo Engraving & Printing Available" },
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Michael Carter",
                date: "September 1, 2024",
                rating: 5,
                content: "Elegant and smooth writing! Perfect for corporate events.",
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Sophia Martinez",
                date: "September 5, 2024",
                rating: 4.8,
                content: "The pens feel premium, and the ink flows beautifully. A great gift item!",
            },
        ],
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "USB Drive",
        price: 15,
        disprice: 12,
        stock: 200,
        content:
            "Store and share your files conveniently with our Corporate USB Drive. Designed for conference attendees and professionals, this high-speed USB drive is perfect for presentations, documents, and promotional materials.",
        description:
            "Our Corporate USB Drive combines reliability and sleek design, making it an essential tool for business professionals and event giveaways. Available in multiple storage capacities and customizable with logo printing for branding purposes.",
        category: ["Tech Accessories", "Promotional Gifts"],
        tags: ["Tech", "Office", "Conference"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Storage Capacity", content: "8GB, 16GB, 32GB, 64GB" },
            { id: 2, title: "Interface", content: "USB 3.0 for Fast Data Transfer" },
            { id: 3, title: "Material", content: "Durable Metal & Plastic Casing" },
            { id: 4, title: "Customization", content: "Logo Printing Available" },
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "James Peterson",
                date: "September 10, 2024",
                rating: 5,
                content: "Super handy and reliable. Great for storing conference materials!",
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Laura Bennett",
                date: "September 12, 2024",
                rating: 4.9,
                content: "Excellent quality and fast transfer speeds. A perfect event giveaway!",
            },
        ],
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Sticky Notes",
        price: 8,
        disprice: 6,
        stock: 300,
        content:
            "Keep your important notes organized with our Event Sticky Notes. Ideal for meetings, conferences, and daily reminders, these sticky notes help you stay productive and efficient.",
        description:
            "Our Event Sticky Notes are perfect for jotting down quick thoughts and to-do lists. Designed with strong adhesive and smooth writing paper, they are a must-have for professionals and event attendees. Available in multiple colors and customizable with logo printing.",
        category: ["Office Supplies", "Event Merchandise"],
        tags: ["Stationery", "Office", "Writing"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Quality Paper with Strong Adhesive" },
            { id: 2, title: "Sizes Available", content: "3x3 inches, 4x6 inches" },
            { id: 3, title: "Colors", content: "Yellow, Blue, Pink, Green" },
            { id: 4, title: "Customization", content: "Logo Printing Available" },
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Mark Thompson",
                date: "September 15, 2024",
                rating: 5,
                content: "Perfect for keeping track of my daily tasks. Sticks well and peels off cleanly!",
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Emily Rogers",
                date: "September 18, 2024",
                rating: 4.8,
                content: "Great quality and vibrant colors. A fantastic addition to my office supplies!",
            },
        ],
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Photo Frame",
        price: 20,
        disprice: 15,
        stock: 0,
        content:
            "Display your cherished memories with our Elegant Photo Frame. Designed for corporate events and home decor, this stylish frame adds a touch of sophistication to any space.",
        description:
            "Our Elegant Photo Frame is a perfect keepsake for event attendees and professionals. Crafted with premium materials and a sleek finish, it is available in multiple sizes and customizable with engraving options.",
        category: ["Promotional Gifts", "Event Merchandise"],
        tags: ["Gifts", "Accessories", "Promo"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Premium Wood & Glass" },
            { id: 2, title: "Sizes Available", content: "4x6 inches, 5x7 inches, 8x10 inches" },
            { id: 3, title: "Mounting Options", content: "Tabletop & Wall Hanging" },
            { id: 4, title: "Customization", content: "Engraving Available" },
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Daniel Carter",
                date: "September 22, 2024",
                rating: 5,
                content: "Beautiful design and high-quality materials. Perfect for my office desk!",
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Sophia Martinez",
                date: "September 25, 2024",
                rating: 4.9,
                content: "Looks elegant and premium. A great gift option for corporate events!",
            },
        ],
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Tote Bag",
        price: 12,
        disprice: 10,
        stock: 250,
        content: "Carry your essentials in style with our Event Tote Bag. Designed for conferences, corporate events, and daily use, this eco-friendly bag is both practical and stylish.",
        description: "Our Event Tote Bag is made from durable and eco-friendly materials, making it a sustainable choice for professionals and attendees. Featuring a spacious design and comfortable handles, it's perfect for carrying documents, laptops, and more. Available in multiple colors and customizable with logo printing.",
        category: ["Event Merchandise", "Branded Apparel"],
        tags: ["Merchandise", "Accessories", "Conference"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "100% Cotton Canvas" },
            { id: 2, title: "Sizes Available", content: "Standard (15x16 inches)" },
            { id: 3, title: "Strap Length", content: "26 inches (Shoulder Length)" },
            { id: 4, title: "Customization", content: "Logo Printing Available" },
        ],
        comments: [
            {
                id: 2,
                image: images.product9Review1,
                name: "Ethan Walker",
                date: "October 1, 2024",
                rating: 4.8,
                content: "Love the quality and eco-friendly design. A must-have for conferences!",
            },
            {
                id: 1,
                image: images.product9Review2,
                name: "Olivia Bennett",
                date: "September 28, 2024",
                rating: 5,
                content: "Spacious and sturdy! Perfect for carrying all my event essentials.",
            },
        ],
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Sports Cap",
        price: 30,
        disprice: 25,
        stock: 100,
        content: "Stay stylish and comfortable with our Sports Cap, perfect for event giveaways and conference merchandise. Designed with a curved brim and adjustable strap, this cap ensures a perfect fit for everyone.",
        description: "Our Sports Cap is a must-have for event attendees and brand promotions. Made from high-quality cotton with breathable panels, it offers a stylish look while keeping you cool. Ideal for branding, conferences, and outdoor events.",
        category: ["Branded Apparel", "Event Merchandise"],
        tags: ["Wearable", "Merchandise", "Promo"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { title: "Material", content: "100% Premium Cotton" },
            { title: "Adjustability", content: "One Size Fits Most (Adjustable Strap)" },
            { title: "Ventilation", content: "Breathable Mesh Panels" },
            { title: "Customization", content: "Embroidery & Logo Printing Available" },
        ],
        comments: [
            {
                name: "Daniel Roberts",
                date: "August 20, 2024",
                rating: 5,
                content: "High-quality cap with a great fit. Perfect for corporate events!",
                image: images.product10Review1,
            },
            {
                name: "Emily Johnson",
                date: "August 25, 2024",
                rating: 4.9,
                content: "Love the comfort and style! The logo customization looks fantastic.",
                image: images.product10Review2,
            },
        ],
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Sweatshirt Hoodie",
        price: 60,
        disprice: 50,
        stock: 100,
        content: "Stay warm and stylish with our Sweatshirt Hoodie, perfect for event giveaways and casual wear. Designed for comfort and durability, this hoodie is a must-have for any conference or promotional event.",
        description: "Our Sweatshirt Hoodie combines fashion and function, making it ideal for both work and leisure. Made from a high-quality cotton blend, it offers a soft feel and a relaxed fit. Perfect for branding, corporate gifts, or everyday wear.",
        category: ["Branded Apparel", "Event Merchandise"],
        tags: ["Wearable", "Merchandise", "Accessories"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { title: "Material", content: "Cotton Blend with Fleece Lining" },
            { title: "Sizes Available", content: "S - XXL" },
            { title: "Fit", content: "Relaxed and Comfortable" },
            { title: "Customization", content: "Logo Printing & Embroidery Available" },
        ],
        comments: [
            {
                name: "Daniel Roberts",
                date: "August 25, 2024",
                rating: 5,
                content: "Super comfortable and great quality! Perfect for chilly event days.",
                image: images.product11Review1,
            },
            {
                name: "Emily Johnson",
                date: "August 28, 2024",
                rating: 4.9,
                content: "Soft, warm, and stylish. A fantastic addition to any conference merchandise lineup!",
                image: images.product11Review2,
            },
        ],
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Writing Pen Kit",
        price: 25,
        disprice: 20,
        stock: 150,
        content: "Elevate your writing experience with our premium Writing Pen Kit, perfect for corporate events, conferences, and promotional giveaways. Designed for smooth writing and a comfortable grip.",
        description: "Our Writing Pen Kit includes high-quality pens that offer a sleek design and smooth ink flow. Ideal for business meetings, workshops, and branding purposes, this kit is a must-have for professionals and event attendees.",
        category: ["Office Supplies", "Promotional Gifts"],
        tags: ["Stationery", "Promo", "Corporate Gift"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { title: "Material", content: "Premium Metal & Plastic Blend" },
            { title: "Ink Type", content: "Smooth Gel & Ballpoint Ink" },
            { title: "Customization", content: "Logo Engraving & Printing Available" },
            { title: "Packaging", content: "Elegant Gift Box Included" },
        ],
        comments: [
            {
                name: "Michael Carter",
                date: "August 22, 2024",
                rating: 5,
                content: "Fantastic pen kit! Writes smoothly and feels premium.",
                image: images.product12Review1,
            },
            {
                name: "Sophia Lee",
                date: "August 26, 2024",
                rating: 4.8,
                content: "Perfect for our corporate event giveaways. The logo print looks great!",
                image: images.product12Review2,
            },
        ],
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Memo Pads",
        price: 15,
        disprice: 12,
        stock: 200,
        content: "Stay organized with our premium Memo Pads, perfect for conferences, office use, and promotional giveaways. Designed for smooth writing and easy portability.",
        description: "Our Memo Pads offer a sleek and professional look, making them ideal for meetings, workshops, and branding. Made with high-quality paper, they ensure a smooth writing experience. Perfect for note-taking and corporate gifting.",
        category: ["Office Supplies", "Event Merchandise"],
        tags: ["Stationery", "Promo", "Corporate Gift"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { title: "Material", content: "Premium Recycled Paper" },
            { title: "Page Count", content: "100 Sheets Per Pad" },
            { title: "Customization", content: "Logo Printing Available" },
            { title: "Size Options", content: "A5, A6, Pocket Size" },
        ],
        comments: [
            {
                name: "James Anderson",
                date: "August 22, 2024",
                rating: 5,
                content: "Great quality paper and perfect size for meetings.",
                image: images.product13Review1,
            },
            {
                name: "Olivia Martinez",
                date: "August 26, 2024",
                rating: 4.8,
                content: "Ideal for conferences! The logo print was crisp and clear.",
                image: images.product13Review2,
            },
        ],
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Picture Frame",
        price: 40,
        disprice: 35,
        stock: 80,
        content: "Display your cherished memories or corporate achievements with our premium Picture Frame. Designed for elegance and durability, it’s ideal for office desks, event souvenirs, or home decor.",
        description: "Our Picture Frame features a sleek, modern design with high-quality materials, making it perfect for gifting or showcasing special moments. Suitable for event awards, brand promotions, or personal use.",
        category: ["Promotional Gifts", "Event Merchandise"],
        tags: ["Decor", "Promo", "Gift Item"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { title: "Material", content: "Premium Wood & Glass" },
            { title: "Photo Size", content: "5x7 inches & 8x10 inches" },
            { title: "Mounting Options", content: "Tabletop & Wall Mount" },
            { title: "Customization", content: "Engraving & Logo Printing Available" },
        ],
        comments: [
            {
                name: "Michael Davis",
                date: "August 27, 2024",
                rating: 4.9,
                content: "Excellent quality and great for corporate gifting!",
                image: images.product14Review1,
            },
            {
                name: "Sophia Wilson",
                date: "August 23, 2024",
                rating: 5,
                content: "Beautiful frame with a premium feel! The engraving was perfect.",
                image: images.product14Review2,
            },
        ],
    }
];

export default products;